export default __webpack_public_path__ + "static/media/Slide13.564e591b.JPG";